import { createIconComponent } from '../../factory/create-icon-component';
export const SingaporeIcon = createIconComponent(
  'SingaporeIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10086_33661)">
      <path d="M23 5H1V20H23V5Z" fill="#F0F0F0" />
      <path d="M23 5H1V12.5H23V5Z" fill="#D80027" />
      <path
        d="M4.58759 8.74988C4.58759 7.65716 5.33851 6.74431 6.34123 6.52031C6.1871 6.48586 6.02721 6.46722 5.86299 6.46722C4.6303 6.46722 3.6311 7.48915 3.6311 8.74984C3.6311 10.0105 4.63034 11.0325 5.86299 11.0325C6.02721 11.0325 6.1871 11.0138 6.34123 10.9794C5.33851 10.7555 4.58759 9.84265 4.58759 8.74988Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.45697 6.63025L7.61526 7.12847H8.12749L7.71306 7.4364L7.87136 7.93462L7.45697 7.62673L7.04253 7.93462L7.20087 7.4364L6.78644 7.12847H7.29867L7.45697 6.63025Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.21374 7.60864L6.37199 8.10686H6.88422L6.46979 8.41479L6.62809 8.91301L6.21374 8.60512L5.79931 8.91301L5.95765 8.41479L5.54321 8.10686H6.05544L6.21374 7.60864Z"
        fill="#F0F0F0"
      />
      <path
        d="M8.69874 7.60864L8.85704 8.10686H9.36927L8.95484 8.41479L9.11313 8.91301L8.69874 8.60512L8.28435 8.91301L8.44269 8.41479L8.02826 8.10686H8.54049L8.69874 7.60864Z"
        fill="#F0F0F0"
      />
      <path
        d="M8.22031 9.07605L8.3786 9.57427H8.89083L8.47644 9.8822L8.63474 10.3804L8.22031 10.0725L7.80596 10.3804L7.96426 9.8822L7.54987 9.57427H8.06205L8.22031 9.07605Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.69209 9.07605L6.85034 9.57427H7.36258L6.94818 9.8822L7.10648 10.3804L6.69209 10.0725L6.2777 10.3804L6.436 9.8822L6.02161 9.57427H6.53379L6.69209 9.07605Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_10086_33661">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
